export const DS_BASE_INPUT_CLASSES = {
  Root: "ds-base-input",
  InputWrapper: "ds-base-input__input-wrapper",
  Input: "ds-base-input__input",
  InputHidden: "ds-base-input__input--hidden",
  InputTextarea: "ds-base-input__input--textarea",
  Prefix: "ds-base-input__prefix",
  PrefixText: "ds-base-input__prefix-text",
  Suffix: "ds-base-input__suffix",
  SuffixText: "ds-base-input__suffix-text",
  WithPrefix: "ds-base-input--with-prefix",
  WithSuffix: "ds-base-input--with-suffix",
  Textarea: "ds-base-input--textarea",
  Clearable: "ds-base-input__clearable",
  Content: "ds-base-input__content",
  Pointer: "ds-base-input__pointer",
  WrapContent: "ds-base-input--wrap-content",
} as const;
